export const STATUS_CONFIG = {
  matched_exact: { label: "Exact Match", color: "#10B981" },
  matched_tolerant: { label: "Tolerant Match", color: "#2563EB" },
  matched_split: { label: "Split Detected", color: "#0891B2" },
  matched_deep_search: { label: "Deep Search", color: "#6366F1" },
  matched_pg: { label: "Payment Gateway", color: "#8B5CF6" },
  matched_phase4b_cross_midnight: { label: "Phase 4B · Cross-Midnight", color: "#7C3AED" },
  matched_phase4b_live_rescue: { label: "Phase 4B · Live Rescue", color: "#7C3AED" },
  matched_gantung_done: { label: "Gantung · Done · Verified", color: "#059669" },
  matched_gantung_done_unverified: { label: "Gantung · Done · Unverified", color: "#D97706" },
  matched_gantung_open: { label: "Gantung · Open", color: "#F97316" },
  auto_bonus: { label: "Bonus Otomatis", color: "#06B6D4" },
  matched_ai_suggested: { label: "AI Suggested", color: "#A855F7" },
  needs_manual_review: { label: "Manual Review", color: "#D97706" },
  not_found: { label: "Not Found", color: "#DC2626" },
  panel_error: { label: "Panel Error", color: "#7F1D1D" },
  sheet_error: { label: "Sheet Error", color: "#CA8A04" },
  pending: { label: "Pending", color: "#71717A" },
  running: { label: "Running", color: "#2563EB" },
  completed: { label: "Completed", color: "#10B981" },
  completed_with_errors: { label: "Has Issues", color: "#D97706" },
  failed: { label: "Failed", color: "#DC2626" },
  waiting_captcha: { label: "Menunggu CAPTCHA", color: "#D97706" },
  system_bonus: { label: "System/Bonus", color: "#6366F1" },
  adjustment: { label: "Adjustment", color: "#EA580C" },
  rejected_panel: { label: "Rejected (Panel)", color: "#9CA3AF" },
  resolved: { label: "Resolved", color: "#64748B" },
};

export function StatusBadge({ status, className = "" }) {
  const config = STATUS_CONFIG[status] || { label: status, color: "#71717A" };
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-2 border border-zinc-200 bg-white px-2 py-1 font-mono text-[11px] uppercase tracking-widest text-zinc-700 rounded-sm ${className}`}
    >
      <span
        className="inline-block h-1.5 w-1.5 rounded-full flex-shrink-0"
        style={{ backgroundColor: config.color }}
      />
      {config.label}
    </span>
  );
}
